import { useToast } from 'vue-toastification'

export default () => {
  const toast = useToast()
  return {
    showErrorNotification: (message) => {
      toast.error(message)
    },
    showSuccessNotification: (message) => {
      toast.success(message)
    }
  }
}
